import SvgIcon from '@mui/material_v7/SvgIcon';

import { IconProps } from './types';

const ExpandMoreIcon = (props: IconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.9998 13.9748C9.86647 13.9748 9.74147 13.954 9.6248 13.9123C9.50814 13.8706 9.3998 13.7998 9.2998 13.6998L4.6998 9.0998C4.51647 8.91647 4.4248 8.68314 4.4248 8.3998C4.4248 8.11647 4.51647 7.88314 4.6998 7.6998C4.88314 7.51647 5.11647 7.4248 5.3998 7.4248C5.68314 7.4248 5.91647 7.51647 6.0998 7.6998L9.9998 11.5998L13.8998 7.6998C14.0831 7.51647 14.3165 7.4248 14.5998 7.4248C14.8831 7.4248 15.1165 7.51647 15.2998 7.6998C15.4831 7.88314 15.5748 8.11647 15.5748 8.3998C15.5748 8.68314 15.4831 8.91647 15.2998 9.0998L10.6998 13.6998C10.5998 13.7998 10.4915 13.8706 10.3748 13.9123C10.2581 13.954 10.1331 13.9748 9.9998 13.9748Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default ExpandMoreIcon;
